import React from 'react';
import { FadeIn } from './FadeIn';
import { Microscope } from 'lucide-react';
export function ScienceSection() {
  const quotes = [{
    topic: 'Sobre la Curcumina:',
    quote: 'La curcumina inhibe el NF-kB, el regulador maestro de la respuesta inflamatoria, con una potencia comparable a los antiinflamatorios de prescripción pero sin sus efectos secundarios gastrointestinales.',
    source: 'Journal of Medicinal Food, 2016'
  }, {
    topic: 'Sobre el Intestino Permeable:',
    quote: 'La hiperpermeabilidad intestinal es un mecanismo fisiopatológico documentado en la artritis reumatoide y la osteoartritis. La restauración de la barrera intestinal reduce los marcadores inflamatorios sistémicos.',
    source: 'Nutrients Journal, 2019'
  }, {
    topic: 'Sobre el Caldo de Huesos:',
    quote: 'Los glucosaminoglicanos y el colágeno hidrolizado derivados del caldo de huesos tienen biodisponibilidad superior a los suplementos comerciales equivalentes a una fracción del costo.',
    source: 'Journal of Agricultural and Food Chemistry, 2017'
  }];
  return <section className="bg-white py-16 px-6 md:px-12 lg:px-24" data-id="element-234">
      <div className="max-w-5xl mx-auto" data-id="element-235">
        <FadeIn data-id="element-236">
          <div className="text-center mb-10" data-id="element-237">
            <Microscope className="w-12 h-12 text-sage mx-auto mb-4" data-id="element-238" />
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-text-black" data-id="element-239">
              No es magia. Es bioquímica.
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-240">
          {quotes.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-241">
              <div className="bg-cream border-t-4 border-sage p-8 rounded-b-xl shadow-md h-full flex flex-col" data-id="element-242">
                <h3 className="text-xl font-bold text-dark-green mb-4" data-id="element-243">
                  {item.topic}
                </h3>
                <p className="text-lg font-serif italic text-text-gray mb-6 flex-grow" data-id="element-244">
                  "{item.quote}"
                </p>
                <p className="text-sm font-bold text-sage uppercase tracking-wider" data-id="element-245">
                  — {item.source}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}